module.exports = __webpack_public_path__ + "img/zhongtai.47891418.png";